/* ====================================================================
   ENHANCEMENTS

   Four things, all progressive: if this file fails to load or throws, the
   site is exactly as it was. Nothing here is required to render or buy.

     1. reveal-on-scroll for sections
     2. a navigation progress bar
     3. keyboard shortcut for search  (/  or  Cmd/Ctrl-K)
     4. fade-in for product-card images
   ==================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. reveal on scroll -----------------------------------------
     ⚠ The hiding is applied by a class on <html>, and ONLY once we know
     IntersectionObserver exists. A stylesheet that hid sections on its own
     would leave the whole page blank for anyone whose JS did not run.

     The first content section is skipped so the hero paints immediately --
     animating what is already above the fold reads as jank, not polish. */
  function reveals() {
    if (reduce || !('IntersectionObserver' in window)) return;

    var all = document.querySelectorAll('.shopify-section');
    var targets = [];
    for (var i = 0; i < all.length; i++) {
      var s = all[i];
      var c = s.className || '';
      if (c.indexOf('header-group') > -1 || c.indexOf('footer-group') > -1 || c.indexOf('overlay-group') > -1) continue;
      targets.push(s);
    }
    targets = targets.slice(1);
    if (!targets.length) return;

    document.documentElement.classList.add('pp-reveal-on');
    for (var j = 0; j < targets.length; j++) targets[j].setAttribute('data-pp-reveal', '');

    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      fired = true;
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) {
          entries[k].target.classList.add('pp-revealed');
          io.unobserve(entries[k].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.02 });

    for (var m = 0; m < targets.length; m++) io.observe(targets[m]);

    function revealAll() {
      for (var n = 0; n < targets.length; n++) targets[n].classList.add('pp-revealed');
    }

    /* Two failsafes, and neither may be short enough to pre-empt normal
       scrolling. ⚠ A blanket 2.5s timer revealed every section before the
       page had settled, which silently disabled the whole effect and still
       measured as "working".
         3s : the observer never called back at all -> it is broken, show
              everything.
         20s: absolute backstop, so content can never be stranded. */
    setTimeout(function () { if (!fired) revealAll(); }, 3000);
    setTimeout(revealAll, 20000);
  }

  /* ---- 2. navigation progress bar ----------------------------------
     Opening the designer takes a few seconds, and a click with no feedback
     reads as a dead button. */
  var bar;
  function startProgress() {
    if (reduce) return;
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'pp-progress';
      document.body.appendChild(bar);
    }
    bar.classList.remove('is-done');
    void bar.offsetWidth;
    bar.classList.add('is-active');
  }

  function watchNavigation() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      var href = a.getAttribute('href') || '';
      if (!href || href[0] === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      startProgress();
    }, true);

    /* The card Personalize button and the product form both POST, so catch
       submits too -- that is the slowest navigation on the site. */
    document.addEventListener('submit', function () { startProgress(); }, true);
    window.addEventListener('pp:navigating', startProgress);

    /* bfcache restore: the bar must not still be sitting there */
    window.addEventListener('pageshow', function () {
      if (bar) { bar.classList.remove('is-active'); bar.classList.add('is-done'); }
    });
  }

  /* ---- 3. search shortcut ------------------------------------------
     475 products is too many to browse for something specific. `/` is the
     convention on content sites, Cmd/Ctrl-K on apps; support both. */
  function searchShortcut() {
    function opener() {
      return document.querySelector('[aria-controls*="Search" i]')
          || document.querySelector('[data-sidebar-id*="Search" i]')
          || document.querySelector('.header__icons-right sidebar-button');
    }
    function focusInput(tries) {
      var i = document.querySelector('input[name="q"], input[type="search"]');
      if (i && i.offsetWidth > 0) { i.focus(); i.select && i.select(); return; }
      if (tries > 0) setTimeout(function () { focusInput(tries - 1); }, 90);
    }
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      var typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
      var slash = e.key === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey;
      var cmdK  = (e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey);
      if (!slash && !cmdK) return;
      var btn = opener();
      if (!btn) return;
      e.preventDefault();
      btn.click();
      focusInput(12);
    });
  }

  /* ---- 4. product image fade-in -------------------------------------
     The class is added AFTER the image reports loaded, so CSS never hides
     an image that has not arrived -- a fade applied up-front is how you
     end up with permanently invisible product photos. */
  function imageFade() {
    if (reduce) return;
    function tag(img) {
      if (img.getAttribute('data-pp-fade')) return;
      img.setAttribute('data-pp-fade', '1');
      if (img.complete && img.naturalWidth > 0) return;
      img.addEventListener('load', function () { img.classList.add('pp-img-in'); }, { once: true });
    }
    function scan() {
      var imgs = document.querySelectorAll('.product-card__img, .product-card img');
      for (var i = 0; i < imgs.length; i++) tag(imgs[i]);
    }
    scan();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    try { reveals(); } catch (e) {}
    try { watchNavigation(); } catch (e) {}
    try { searchShortcut(); } catch (e) {}
    try { imageFade(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
